import React from 'react'
import { useSwipeable, Swipeable } from 'react-swipeable'
import iconPaste from '../svgs/icons'
import {ReactComponent as IconClose} from '../svgs/close.svg';
import {ReactComponent as IconChart} from '../svgs/chart.svg';
import {ReactComponent as IconThOff} from '../svgs/thermostat_off.svg';
import {ReactComponent as IconThAuto} from '../svgs/thermostat_auto.svg';
import {ReactComponent as IconThCool} from '../svgs/thermostat_cool.svg';
import {ReactComponent as IconThHeat} from '../svgs/thermostat_heat.svg';
import {ReactComponent as IconThDry} from '../svgs/thermostat_dry.svg';
import {ReactComponent as IconThFan} from '../svgs/thermostat_fan.svg';
import {ReactComponent as IconThFanIn} from '../svgs/thermostat_fan_in.svg';
import {ReactComponent as IconThFanOut} from '../svgs/thermostat_fan_out.svg';
import css_lib from '../lib/styles/css-lib'

export default function ElementPage({element_id, config, ui_language, params, newColor, newColorUp, newBright, newBrightUp, newTargetPos, newTargetPosUp, newSaturation, newSaturationUp, newSwState, clickPlus, clickMinus, toNormalState, toChartState, clickMode}){    
    
    const classes = []
    let fill_style
    let element_name 
    let element_type
    let element_room_name
    let ui_element_svg_id
    let rooms = config.ui_rooms
    let element_page_content = ''
    let start_color = 0
    let start_bright = 0
    let start_curr_pos = 0
    let start_target_pos = 0
    let start_saturation = 0
    let start_state = 0
    let status_data = 0
    let start_curr_temp = 0
    let start_comf_temp = 0
    let start_mode = 0
    let modes = []
    let modes_line1 = ''
    let thermo_units
    let element_params
    let ui_element_add_data
    let iconSvg
    let css_var = document.querySelector('body')
    let chart_button = <div className="chart_elementPage" onClick={() => toChartState(element_id, 604800000)}><IconChart /></div>

    config.ui_items.map(item => {
        if (item.ui_item_id === element_id) {
            element_name = item.display_name
            element_type = item.ui_item_type
            element_params = item.params
            ui_element_svg_id = item.ui_item_icon_id
            ui_element_add_data = JSON.parse(item.add_data)
            rooms.map(room => {
                if (item.ui_room_id === room.ui_room_id) element_room_name = room.ui_room_name
            })
        }
    }
    )

    const [color, setColor] = React.useState(start_color)
    const [brightness, setBright] = React.useState(start_bright)
    const [saturation, setSaturation] = React.useState(start_saturation)
    const [sw_state, setSwState] = React.useState(false)
    const [curr_temp, setCurrTemp] = React.useState(start_curr_temp)
    const [comf_temp, setComfTemp] = React.useState(start_comf_temp)
    const [curr_pos, setCurrPos] = React.useState(start_curr_pos)
    const [target_pos, setTargetPos] = React.useState(start_target_pos)
    const [mode, setMode] = React.useState(start_mode)

    switch (element_type) {
        case 'switch':
            element_params.map(param =>{
                if(param.param_sub_id === 'state') {
                    if (!param.is_history_save) chart_button = null
                    let par_id = param.param_id
                    params.map( state=>{
                        if(parseInt(state.param_id) === par_id) {
                            start_state = state.param_value
                        }
                    })
                }
            })

            if (start_state === 'true') css_var.style.setProperty('--svg_color', 'var(--switch_on_color)')
            else css_var.style.setProperty('--svg_color', 'var(--switch_off_color)')
            if ((start_state === 'true')&&(sw_state === false)) setSwState(true)
            else if ((start_state === 'false')&&(sw_state === true)) setSwState(false)
            break;
        
        case 'rgb':
        case 'rgbw':
            element_params.map(param =>{
                if(param.param_sub_id === 'hue') {
                    let par_id = param.param_id
                    if (!param.is_history_save) chart_button = null
                    params.map( state=>{
                        if(parseInt(state.param_id) === par_id) {
                            if (state.param_value) start_color = parseInt(state.param_value)
                            else start_color = 0
                        }
                    })
                }
                else if(param.param_sub_id === 'bright') {
                    let par_id = param.param_id
                    if (!param.is_history_save) chart_button = null
                    params.map( state=>{
                        if(parseInt(state.param_id) === par_id) {
                            start_bright = parseInt(state.param_value)
                            if (state.param_value) start_bright = parseInt(state.param_value)
                            else start_bright = 0
                        }
                    })
                }
                else if(param.param_sub_id === 'saturation') {
                    let par_id = param.param_id
                    params.map( state=>{
                        if(parseInt(state.param_id) === par_id) {
                            if (state.param_value) start_saturation = parseInt(state.param_value)
                            else start_saturation = 0
                        }
                    })
                }
            })
            if (color !== start_color) setColor(start_color)
            if (brightness !== start_bright) setBright(start_bright)
            if (saturation !== start_saturation) setSaturation(start_saturation)
            break;

        case 'warm_cold':
            element_params.map(param =>{
                if(param.param_sub_id === 'hue') {
                    if (!param.is_history_save) chart_button = null
                    let par_id = param.param_id
                    params.map( state=>{
                        if(parseInt(state.param_id) === par_id) {
                            if (state.param_value) start_color = parseInt(state.param_value)
                            else start_color = 0
                        }
                    })
                }
                else if(param.param_sub_id === 'bright') {
                    let par_id = param.param_id
                    params.map( state=>{
                        if(parseInt(state.param_id) === par_id) {
                            if (state.param_value) start_bright = parseInt(state.param_value)
                            else start_bright = 0
                        }
                    })
                }
            })
            if (color !== start_color) setColor(start_color)
            if (brightness !== start_bright) setBright(start_bright)
            break;
    
        case 'dimmer':
            element_params.map(param =>{
                if(param.param_sub_id === 'bright') {
                    if (!param.is_history_save) chart_button = null
                    let par_id = param.param_id
                    params.map( state=>{
                        if(parseInt(state.param_id) === par_id) {
                            if (state.param_value) start_bright = parseInt(state.param_value)
                            else start_bright = 0
                        }
                    })
                }
            })
            if (start_bright === 0) css_var.style.setProperty('--color', 'var(--switch_off_color)')
            else {css_var.style.setProperty('--color', 'rgb('+((start_bright+20)*255/120)+','+((start_bright+20)*255/120)+','+((start_bright+20)*255/120)+')')}
            if (brightness !== start_bright) setBright(start_bright)
            break;

        case 'status':
            element_params.map(param =>{
                if(param.param_sub_id === 'text') {
                    if (!param.is_history_save) chart_button = null
                    let par_id = param.param_id
                    params.map( state=>{
                        if(parseInt(state.param_id) === par_id) {
                            status_data = state.param_value
                        }
                    })
                }
            })
            let status_type = 'text'
            let add = ''
            if (ui_element_add_data) status_type = ui_element_add_data.type
            switch (status_type) {
                case 'text':
                    if (status_data == null) status_data = ''
                    else status_data = status_data.toString().replace(/"/g,'')
                    if ((ui_element_add_data)) add = (ui_element_add_data).units
                    break;
                case 'icon_activity':
                case 'icon_status_color':
                    if ((ui_element_add_data)) add = (ui_element_add_data).icon_id
                    break;
            }
            switch (status_type) {
                default:
                case 'text':
                    status_data = <div className="status">{status_data} {add}</div>
                    break;
                case 'icon_activity':
                    if (status_data == 'true') classes.push('switch-true')
                    else fill_style = {filter: 'blur(1px)', transform: 'scale(0.95)', fill:'var(--switch_off_color)'}
        
                    status_data = <div className={'switch ' + classes.join(' ')}>
                        <div className={'icon ' + classes.join(' ')} style={fill_style}>{iconPaste(add)}</div>
                    </div>
                    break;
                case 'icon_status_color':
                    if (status_data == 'ok') {
                        classes.push('switch-ok')
                        fill_style = {filter: 'blur(1px)', transform: 'scale(0.95)'}
                    }
                    else if (status_data == 'warning') classes.push('switch-warning')
                    else if (status_data == 'error') {
                        classes.push('switch-error')
                    }
        
                    status_data = <div className={'switch ' + classes.join(' ')}>
                        <div className={'icon ' + classes.join(' ')} style={fill_style}>{iconPaste(add)}</div>
                    </div>
                    break;
            }
            break;

        case 'thermostat':
            element_params.map(param =>{
                if(param.param_sub_id === 'curr_temp') {
                    if (!param.is_history_save) chart_button = null
                    let par_id = param.param_id
                    params.map( state=>{
                        if(parseInt(state.param_id) === par_id) {
                            start_curr_temp = state.param_value
                        }
                    })
                }
                else if(param.param_sub_id === 'comf_temp') {
                    let par_id = param.param_id
                    params.map( state=>{
                        if(parseInt(state.param_id) === par_id) {
                            start_comf_temp = state.param_value
                        }
                    })
                }
                else if(param.param_sub_id === 'mode') {
                    let par_id = param.param_id
                    params.map( state=>{
                        if(parseInt(state.param_id) === par_id) {
                            if (state.param_value) start_mode = parseInt(state.param_value)
                        }
                    })
                }
            })
            if(ui_element_add_data) {
                thermo_units = ui_element_add_data.units
                if(ui_element_add_data.hasOwnProperty('modes')) modes = ui_element_add_data.modes
            }
            if (curr_temp !== start_curr_temp) setCurrTemp(start_curr_temp)
            if (comf_temp !== start_comf_temp) setComfTemp(start_comf_temp)
            if (mode !== start_mode) setMode(start_mode)
        break;

        case 'curtains':
            element_params.map(param =>{
                if(param.param_sub_id === 'curr_pos') {
                    if (!param.is_history_save) chart_button = null
                    let par_id = param.param_id
                    params.map( state=>{
                        if(parseInt(state.param_id) === par_id) {
                            if (state.param_value) start_curr_pos = parseInt(state.param_value)
                            else start_curr_pos = 0
                        }
                    })
                }
                else if(param.param_sub_id === 'target_pos') {
                    let par_id = param.param_id
                    params.map( state=>{
                        if(parseInt(state.param_id) === par_id) {
                            if (state.param_value) start_target_pos = parseInt(state.param_value)
                            else start_target_pos = 0
                        }
                    })
                }
            })
            if (curr_pos !== start_curr_pos) setCurrPos(start_curr_pos)
            if (target_pos !== start_target_pos) setTargetPos(start_target_pos)
            if (curr_pos == target_pos) css_var.style.setProperty('--svg_color', 'var(--switch_off_color)')
            else css_var.style.setProperty('--svg_color', 'var(--switch_on_color)')

            if (curr_pos > 80) iconSvg = iconPaste(ui_element_svg_id)
            else if (curr_pos > 60) iconSvg = iconPaste(ui_element_svg_id+'_1')
            else if (curr_pos > 40) iconSvg = iconPaste(ui_element_svg_id+'_2')
            else if (curr_pos > 20) iconSvg = iconPaste(ui_element_svg_id+'_3')
            else iconSvg = iconPaste(ui_element_svg_id+'_4')
        break;
    }

    function updateRgbSliderStyles(){
        var color_style = document.querySelector('body')
        color_style.style.setProperty('--color', css_lib.updateRgbSliderStyle(color))
        if(brightness>0) color_style.style.setProperty('--svg_color', css_lib.parseHueToRGB(color, brightness, saturation))
        else color_style.style.setProperty('--svg_color', 'var(--switch_off_color)')
    }

    function updateWcSliderStyles(){
        var color_style = document.querySelector('body')
        color_style.style.setProperty('--color', css_lib.updateWcSliderStyle(color))
        if(brightness>0) color_style.style.setProperty('--svg_color', css_lib.parseWcToRGB(color, brightness))
        else color_style.style.setProperty('--svg_color', 'var(--switch_off_color)')
    }

    function updateDimmerStyles(){
        var color_style = document.querySelector('body')
        if(brightness>0) color_style.style.setProperty('--svg_color', css_lib.parseDimmerToRGB(brightness))
        else color_style.style.setProperty('--svg_color', 'var(--switch_off_color)')
    }
    
    switch (element_type) {
        case 'switch':
            element_page_content = 
                <div>
                    <div className="bright_value">
                        <div className="icon_page">{iconPaste(ui_element_svg_id)}</div>
                    </div>
                    <Swipeable onSwipedUp = {()=>{setSwState(true); newSwState(element_id, true)}} onSwipedDown = {()=>{setSwState(false); newSwState(element_id, false)}}>
                        <div className="element_control"><input type="checkbox" checked={sw_state} onChange={e => {setSwState(e.target.checked); newSwState(element_id, e.target.checked)}}/></div>
                    </Swipeable>
                </div>
            break;

        case 'rgb':
        case 'rgbw':
            element_page_content = 
                <div>
                <div className="bright_value">{brightness} %
                    <div className="icon_page">{iconPaste(ui_element_svg_id)}</div>
                </div>
                    <input type="range" min="0" max="100" step="1" className="brightness" value={brightness} onChange={e => {setBright(e.target.value); newBright(element_id, e.target.value)}} onTouchEnd={e => {newBrightUp(element_id, e.target.value)}} onPointerUp={e => {newBrightUp(element_id, e.target.value)}}/>
                    <input type="range" min="0" max="100" step="1" className="saturation" value={saturation} onInput={e => {setSaturation(e.target.value); newSaturation(element_id, e.target.value)}} onTouchEnd={e => {newSaturationUp(element_id, e.target.value)}} onPointerUp={e => {newSaturationUp(element_id, e.target.value)}}/>
                    <input type="range" min="0" max="100" step="1" className="color"  value={color} onInput={e => {setColor(e.target.value); newColor(element_id, e.target.value)}} onTouchEnd={e => {newColorUp(element_id, e.target.value)}} onPointerUp={e => {newColorUp(element_id, e.target.value)}}/>
                    <div className="colors_container">
                        <span className='color_red' onClick={() => {setSaturation(100); newSaturationUp(element_id, 100); setColor(0); newColorUp(element_id, 0);}}></span>
                        <span className='color_orange' onClick={() => {setSaturation(100); newSaturationUp(element_id, 100); setColor(17); newColorUp(element_id, 17);}}></span>
                        <span className='color_green' onClick={() => {setSaturation(100); newSaturationUp(element_id, 100); setColor(33); newColorUp(element_id, 33);}}></span>
                        <span className='color_turquoise' onClick={() => {setSaturation(100); newSaturationUp(element_id, 100); setColor(53); newColorUp(element_id, 53);}}></span>
                        <span className='color_blue' onClick={() => {setSaturation(100); newSaturationUp(element_id, 100); setColor(66); newColorUp(element_id, 66);}}></span>
                        <span className='color_coral' onClick={() => {setSaturation(100); newSaturationUp(element_id, 100); setColor(90); newColorUp(element_id, 90);}}></span>
                        <span className='color_white' onClick={() => {setSaturation(0); newSaturationUp(element_id, 0);}}></span>
                        <span className='color_random' onClick={() => {let rnd_clr = Math.floor(Math.random() * 100); setSaturation(100); newSaturationUp(element_id, 100); setColor(rnd_clr); newColorUp(element_id, rnd_clr);}}></span>
                    </div>
                </div>
            updateRgbSliderStyles()
            break;
        
        case 'warm_cold':
            element_page_content = 
                <div>
                <div className="bright_value">{brightness} %
                    <div className="icon_page">{iconPaste(ui_element_svg_id)}</div>
                </div>
                    <input type="range" min="0" max="100" step="1" className="wc_brightness" value={brightness} onInput={e => {setBright(e.target.value); newBright(element_id, e.target.value)}} onTouchEnd={e => {newBrightUp(element_id, e.target.value)}} onPointerUp={e => {newBrightUp(element_id, e.target.value)}}/>
                    <input type="range" min="0" max="100" step="1" className="wc_color"  value={color} onInput={e => {setColor(e.target.value); newColor(element_id, e.target.value)}} onTouchEnd={e => {newColorUp(element_id, e.target.value)}} onPointerUp={e => {newColorUp(element_id, e.target.value)}}/>
                </div>
            updateWcSliderStyles()
            break;
        
        case 'dimmer':
            element_page_content = 
                <div>
                <div className="bright_value">{brightness} %
                    <div className="icon_page">{iconPaste(ui_element_svg_id)}</div>
                </div>
                    <input type="range" min="0" max="100" step="1" className="dimmer_brightness" value={brightness} onInput={e => {setBright(e.target.value); newBright(element_id, e.target.value)}} onTouchEnd={e => {newBrightUp(element_id, e.target.value)}} onPointerUp={e => {newBrightUp(element_id, e.target.value)}}/>
                </div>
            updateDimmerStyles()
            break;

        case 'status':
            element_page_content = 
                <div className="status_content">
                    {status_data}
                </div>
            break;

        case 'thermostat':
            element_page_content = 
            <div className="thermostat_page">
                <div className="thermostat_line">
                    <div className="thermostat_page_comf_temp">{start_comf_temp}</div>
                    <div className="thermostat_page_plus" onClick={()=> clickPlus(element_id)}> + </div>
                </div>
                <div className="thermostat_line">
                    <div className="thermostat_page_curr_temp">{start_curr_temp}{thermo_units}</div>
                    <div className="thermostat_page_minus" onClick={()=> clickMinus(element_id)}> - </div>
                </div>
                <div className="thermostat_page_modes1">
                {modes.map ( modei => {
                    modes_line1 = ''
                    let mode_class = 'thermostat_mode'
                    switch (modei) {
                        case 1: //off
                            if (mode === modei) mode_class = 'thermostat_mode_active'
                            modes_line1 = <div className={mode_class}> <div className="icon" onClick = {()=>clickMode(element_id, 1)}><IconThOff /></div> </div>
                        break
                        case 2: //auto
                            if (mode === modei) mode_class = 'thermostat_mode_active'
                            modes_line1 = <div className={mode_class}> <div className="icon" onClick = {()=>clickMode(element_id, 2)}><IconThAuto/></div> </div>
                        break
                        case 3: //cool
                            if (mode === modei) mode_class = 'thermostat_mode_active'
                            modes_line1 = <div className={mode_class}> <div className="icon" onClick = {()=>clickMode(element_id, 3)}><IconThCool/></div> </div>
                        break
                        case 4: //heat
                            if (mode === modei) mode_class = 'thermostat_mode_active'
                            modes_line1 = <div className={mode_class}> <div className="icon" onClick = {()=>clickMode(element_id, 4)}><IconThHeat/></div> </div>
                        break
                    }
                    if (modes_line1 !== '') return modes_line1
                }) 
                }
                </div>
                <div className="thermostat_page_modes2">
                    {modes.map ( modei => {
                        let mode_class = 'thermostat_mode'
                        let modes_line2 = ''
                        switch (modei) {
                            case 5: //draining
                                if (mode === modei) mode_class = 'thermostat_mode_active'
                                modes_line2 = <div className={mode_class}> <div className="icon" onClick = {()=>clickMode(element_id, 5)}><IconThDry/></div> </div>
                            break
                            case 6: //fan
                                if (mode === modei) mode_class = 'thermostat_mode_active'
                                modes_line2 = <div className={mode_class}> <div className="icon" onClick = {()=>clickMode(element_id, 6)}><IconThFan/></div> </div>
                            break
                            case 7: //fan in
                                if (mode === modei) mode_class = 'thermostat_mode_active'
                                modes_line2 = <div className={mode_class}> <div className="icon" onClick = {()=>clickMode(element_id, 7)}><IconThFanIn/></div> </div>
                            break
                            case 8: //fan out
                                if (mode === modei) mode_class = 'thermostat_mode_active'
                                modes_line2 = <div className={mode_class}> <div className="icon" onClick = {()=>clickMode(element_id, 8)}><IconThFanOut/></div> </div>
                            break
                        }
                        if (modes_line2 !== '') return modes_line2
                    }) 
                    }
                </div>
                <div className="thermostat_page_vertline"></div>
                <div className="thermostat_page_gorline"></div>
            </div>
            break;

        case 'curtains':
            element_page_content = 
                <div>
                <div className="bright_value">{target_pos} %
                    <div className="icon_page">{iconSvg}</div>
                </div>
                    <input type="range" min="0" max="100" step="1" className="dimmer_brightness" value={target_pos} onInput={e => {setTargetPos(e.target.value); newTargetPos(element_id, e.target.value)}} onTouchEnd={e => {newTargetPosUp(element_id, e.target.value)}} onPointerUp={e => {newTargetPosUp(element_id, e.target.value)}}/>
                </div>
        break;
    }

    return(
        <div>
            <div className="elementPageEmpty" onClick={() => toNormalState()}></div>
            <div className="elementPage">
                <div className="close_elementPage" onClick={() => toNormalState()}><IconClose /></div>
                {chart_button}
                <div className="content-top"> {element_room_name} </div>
                <div className="elementContent"> {element_page_content}</div>
                <div className="content-bottom"> {element_name} </div>
            </div>
        </div>
    )

}